import { useState, useEffect, useCallback } from 'react';
import Cookies from 'universal-cookie';

const useAuthTokens = () => {
  const cookies = new Cookies();
  const csrfTokenFromCookies = cookies.get('X-CSRF-TOKEN');
  const [accessToken, setAccessToken] = useState(() =>
    localStorage.getItem('accessToken')
  );

  const [csrfToken, setCsrfTokenState] = useState(csrfTokenFromCookies);
  // Set tokens in both state and localStorage
  const setTokens = useCallback((tokens) => {
    if (tokens?.accessToken) {
      localStorage.setItem('accessToken', tokens.accessToken);
      setAccessToken(tokens.accessToken);
    }
  }, []);
  const refreshCsrfToken = () => {
    setCsrfTokenState(csrfTokenFromCookies);
  };

  // Fetch tokens from localStorage
  // const getTokens = useCallback(
  //   () => ({
  //     accessToken: localStorage.getItem('accessToken'),
  //     csrfToken: localStorage.getItem('csrfToken'),
  //   }),
  //   []
  // );

  // Clear tokens from both state and localStorage
  const clearTokens = useCallback(() => {
    localStorage.removeItem('accessToken');
    setAccessToken(null);
    setCsrfTokenState(null);
  }, []);

  return { accessToken, csrfToken, setTokens, clearTokens, refreshCsrfToken };
};

export default useAuthTokens;
